
import { FieldMeta } from '@/modules/dynamic-form/models/FieldMeta.model';
import { FieldSchema } from '@/modules/dynamic-form/models/FieldSchema.model';

// this function is only used to create simple flat type fields
export function createSimpleFieldDefaultMeta(schema: FieldSchema): FieldMeta {
    return {
        ...schema,
        defaultValue: undefined,
    };
}
